import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import Raven from 'raven-js';
import ToolDescription from './ToolDescription';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AdditionalMoreToolsContent({
  canCreateDragDropEmail,
  hasFullDashboardAccess,
  hasSoftLimit,
  hasTransactionalSMTP,
  isHubSpotter,
  portalId,
  onManageSendingLimitsClick
}) {
  const showAdditionalTools = isHubSpotter && !canCreateDragDropEmail || !hasFullDashboardAccess || hasTransactionalSMTP && hasFullDashboardAccess || !hasSoftLimit;
  if (!showAdditionalTools) {
    return null;
  }
  if (portalId === undefined) {
    Raven.captureException(new Error('portal id is undefined when trying to render additional more tools'));
  }
  return /*#__PURE__*/_jsxs(UIList, {
    children: [!hasFullDashboardAccess && portalId !== undefined && /*#__PURE__*/_jsxs(UIButton, {
      href: `/file-manager-beta/${portalId}`,
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.manage.moreTools.fileManager"
      }), /*#__PURE__*/_jsx(ToolDescription, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.manage.moreTools.fileManagerDescription"
        })
      })]
    }), hasTransactionalSMTP && hasFullDashboardAccess && portalId !== undefined && /*#__PURE__*/_jsxs(UIButton, {
      href: `/settings/${portalId}/marketing/email/smtp`,
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.manage.moreTools.manageSMTP"
      }), /*#__PURE__*/_jsx(ToolDescription, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.manage.moreTools.manageSMTPDescription"
        })
      })]
    }), !hasSoftLimit && /*#__PURE__*/_jsxs(UIButton, {
      onClick: onManageSendingLimitsClick,
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.manage.moreTools.sendingLimits"
      }), /*#__PURE__*/_jsx(ToolDescription, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.manage.moreTools.sendingLimitsDescription"
        })
      })]
    })]
  });
}
export default AdditionalMoreToolsContent;